import { useDispatch } from 'react-redux';
import { addNotificationToApp, NotificationType } from '../../actions/NotificationsActions';


/**
 * Use this hook to gain access to functions capable of creating application-wide
 * notifications to the UI.
 * 
 * This is a convenience hook that abstracts away the state management aspect of
 * sending state updates to the application notification manager.
 */
export const useNotifications = () => {
    const dispatch = useDispatch();

    // Note: the inline lambdas are wrapped in extra brackets so the return type is void and not the return type
    // of the dispatch function. It's just easier to read / consume at implementation sites.
    return {
        notifySuccess: (message: string) => { dispatch(addNotificationToApp(message, NotificationType.Success)); },
        notifyError: (message: string) => { dispatch(addNotificationToApp(message, NotificationType.Error)); }
    };
};